import { ArchivalAidMetadata } from 'types';
import { separatorJoin, SeparatorJoinItem } from 'utils/separatorJoin';

export const getArchivalAidQuote = (
  archivalAid: ArchivalAidMetadata,
  withDot?: boolean
) => {
  const authors = archivalAid?.authors
    ?.map((a) => {
      return `${a.preferredName?.primaryPart}, ${a.preferredName?.secondaryPart}`;
    })
    .join('-');

  const yearOfOrigin = archivalAid?.yearOfOrigin?.toString();

  const quoteParts: SeparatorJoinItem[] = [
    [authors, '. '],
    [archivalAid?.name, ' '],
    [archivalAid?.timeRange, '. '],
    archivalAid?.type,
    yearOfOrigin,
  ];

  return `${separatorJoin(quoteParts, ', ')}${withDot ? '.' : ''}`;
};
